import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LS } from 'src/app/helpers/localStorage.enum';
import { DataService } from 'src/app/services/data/data.service';
import { FileService } from 'src/app/services/file/file.service';
import { UserService } from 'src/app/services/user/user.service';
import * as dateformat from 'dateformat'
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
@Component({
  selector: 'app-card-medium',
  templateUrl: './card-medium.component.html',
  styleUrls: ['./card-medium.component.sass']
})
export class CardMediumComponent implements OnInit, OnDestroy {
  @Input() title: string
  @Input() description: string
  @Input() coordinate: any[]
  @Input() redirectRoute: string
  @Input() exportLabel: string
  @Input() redirectLabel: string
  @Input() hasAction: boolean
  @Input() hasAvatar: boolean
  @Input() avatar: string
  @Input() isShowTable: boolean = false
  csvData
  formAvatar: FormGroup
  user_id
  activatedRouterSub: Subscription;
  fileServiceCreateSub: Subscription;

  currentUser

  isExpanded = true
  favImages: any;
  currentSlide: number = 0;
  modalRef: BsModalRef
  currLoc;
  currLocSub: Subscription;


  @ViewChild('carousel') carousel: TemplateRef<any>

  constructor(
    private fileService: FileService,
    private userService: UserService,
    private activatedRouter: ActivatedRoute,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private _t: TranslateService,
    private modalService: BsModalService,
    private dataService: DataService,
    private router: Router,
    private locationStore: LocationStoreService
  ) { }

  ngOnInit(): void {
    // this.dataService.cardMediumExpanded$.next(this.isExpanded)

    this.currLocSub = this.locationStore.currLocation$.subscribe(res => {
      if (res.id) {
        
        this.currLoc = res.id
      }
    })

    this.formAvatar = this.formBuilder.group({
      user: ['', Validators.required],
      avatar: ['', Validators.required]
    });

    this.dataService.localStorageSub$.subscribe(res => {
      if (Object.keys(res).length === 0 && res.constructor === Object) {
        const currUserStr = localStorage.getItem(LS.currentUser)
          , currentUser = currUserStr ? JSON.parse(currUserStr) : {};
        this.currentUser = currentUser
      } else if (res.key === LS.currentUser) {
        const currUserStr = res.data
          , currentUser = currUserStr ? JSON.parse(currUserStr) : {};
        this.currentUser = currentUser
      }
    })

    this.activatedRouterSub = this.activatedRouter.params.subscribe(params => {
      this.user_id = params['id']
      this.formAvatar.patchValue({
        user: this.user_id
      })
    })

    this.dataService.featureImages$.subscribe(favImages => {
      setTimeout(() => {
        this.favImages = favImages
      }, 2000);
    });

    if (this.exportLabel) this.getCsvData()
  }

  async getCsvData() {
    const csvData = await this.userService.findAllUserLogins().toPromise()
    const data = []
    for (const csv of csvData) {
      data.push({
        [this._t.instant('Date')]: csv?.Date,
        [this._t.instant('Name')]: csv?.Name,
        [this._t.instant('Role')]: csv?.Role,
        [this._t.instant('Email')]: csv?.Email,
        [this._t.instant('First Seen')]: dateformat(new Date(csv['First Seen']), 'h:MM:ss tt'),
        [this._t.instant('Last Seen')]: dateformat(new Date(csv['Last Seen']), 'h:MM:ss tt'),
      })
    }
    this.csvData = data
    
  }

  tableButton() {
    const findUrl = this.router.url.split('/').slice(-1).toString();

    switch (findUrl) {
      case 'history': { this.router.navigate(['/projects', this.currLoc, 'tables', findUrl]); break; }
      case 'tasks': { this.router.navigate(['/projects', this.currLoc, 'tables', findUrl]); break; }
      case 'attachment': { this.router.navigate(['/projects', this.currLoc, 'tables', findUrl]); break; }
      default: { this.router.navigate(['/projects', this.currLoc, 'tables', 'annotations']); break; }
    }

  }

  onUploadAvatar(event) {
    this.spinner.show()
    const file = event.target.files[0]
    this.formAvatar.patchValue({
      avatar: file
    })

    if (!this.formAvatar.get('user').value)
      this.formAvatar.patchValue({ 'user': this.currentUser.user_id })

    const formData = new FormData();
    formData.append('avatar', this.formAvatar.get('avatar').value)
    formData.append('user', this.formAvatar.get('user').value)
    if (this.formAvatar.valid) {
      this.fileServiceCreateSub = this.fileService.create(formData).subscribe(res => {
        this.avatar = `url("${res[0].url}")`
        this.spinner.hide();
      }, ({ error }) => {
        this.spinner.hide();
        const msg = error.message.reduce((results, u) => (results += u + ', ', results), '').slice(0, -2)
        this.toastr.error(msg, this._t.instant('Error'));
      });
    }
  }

  ngOnDestroy() {
    this.activatedRouterSub.unsubscribe()
    if (this.fileServiceCreateSub) this.fileServiceCreateSub.unsubscribe()
    this.currLocSub.unsubscribe()
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded
    // this.dataService.cardMediumExpanded$.next(this.isExpanded)
  }

  showCarousel(slideIndex) {
    this.currentSlide = slideIndex
    //show modal
    this.modalRef = this.modalService.show(this.carousel, {
      class: 'modal-lg gallery2'
    })
  }

  closeFavImage() {
    this.dataService.featureImages$.next([])
  }

  onNavCarousel(currentSlide: number) {
    this.currentSlide = currentSlide;
  }
}
